import gql from "graphql-tag";
import { graphql, compose } from "react-apollo";

export const getUsersQuery = gql`
    query users($filterBy: [JSONString], $offset: Int = 0, $pageSize: Int = 10, $sort: [JSONString], $project: Int = 0) {
        users(filterBy: $filterBy, offset: $offset, pageSize: $pageSize, sort: $sort, project: $project) {
            users {
              uid
              username
              address
              active
              phone
              usertype
              projects {
                edges {
                  node {
                    name
                    pid
                  }
                }
              }
            }
            pages
            hasNext
            hasPrev
        }
    }

`

export const getUserQuery = gql`
        query user ($uid: Int!) {
                user(uid: $uid) {
                        uid
                        username
                        password
                        address
                        phone
                        usertype
                        active
                }
        }
`


export const getUserSub = gql`
  subscription {
    userSub{
      jsonObject
    }
  }
`;

export const manageUserStatus = gql`
        mutation manageUserStatus($uid: Int!, $status: Boolean!){
            manageUserStatus(uid: $uid, status: $status){
                deleteusr{
                    uid
        }
    }
}`

export const createUsersMutation = gql`
    mutation createUsers($pid: Int!, $userCount: Int!, $userType: Int!, $username: String!, $groupName: String, $groupType: Int!){
        createUsers(pid: $pid, userCount: $userCount, userType: $userType, username: $username, groupName: $groupName, groupType: $groupType){
            jsonObject
        }
    }
`

export const getUserPassword = gql`
    mutation getUserPassword($uid: Int!){
        getUserPassword(uid: $uid){
            pwd
        }
    }
`

export const getAllProjects = gql`
    query {
      allProjects {
        edges {
            node {
            pid
            name
          }
        }
      }
    }
`
export const getProjectGroups = gql`
    query getProjectGroups($pid: Int, $projid: Int){
        getProjectGroups(pid: $pid, projid: $projid){
            groupId
            name
            usersGroup {
              edges {
                node {
                  uid
                }
              }
            }

        }
    }
`

export const getUserGroups = gql`
    query getGroupMembers($groupId: Int!){
        getGroupMembers(groupId: $groupId){
            username
            uid
        }
    }
`

export const deleteGroup = gql`
    mutation deleteGroup($groupId: Int!){
        deleteGroup(groupId: $groupId){
            status
        }
    }
`

export const deleteUserFromGroup = gql`
    mutation deteleUserFromGroup($userId: Int!, $groupId: Int!){
        deleteUserFromGroup(userId: $userId, groupId: $groupId){
            status
        }
    }
`

export const getProjectUsers = gql`
    query getProjectUsers($pid: Int!){
        getProjectUsers(pid: $pid){
            username
            uid
        }
    }
`

export const addMembersToGroup = gql`
    mutation addMembersToGroup($users: [Int]!, $groupId: Int!){
        addMembersToGroup(users: $users, groupId: $groupId){
            status
        }
    }
`

export const getGroups = compose(
    graphql(getProjectGroups, {
        options: (props) => ({
            variables: {
                pid: props.pid
            },
            errorPolicy: "all",
            fetchPolicy: "network-only"
        }),
        name: "getProjectGroups"
    })
); 

export const createUsers = compose(
    graphql(createUsersMutation, {
        options: {
            errorPolicy: "all"
        },
        name: "createUsers"
        }),
    graphql(getProjectGroups, {
        options: (props) => ({
            variables: {
                pid: props.pid
            },
            errorPolicy: "all",
            fetchPolicy: "network-only"
        }),
        name: "getProjectGroups"
    })
);

export const mutateUsers = gql`
        mutation mutateUser($uid: Int!, $username: String!, $address: String){
            mutateUser(uid: $uid, username: $username, address: $address){
                usr{
                    uid
                    username
                    address
        }
    }
}`

export const userData = compose(
        graphql(getUsersQuery, {
            options: (props) => ({
                    variables: { 
                        offset: 0, 
                        pageSize: 10
                    },
                    errorPolicy: "all",
                    fetchPolicy: 'cache-and-network'
            }),
            name: "getUsersQuery"
        }), graphql(manageUserStatus, {
                name: "ManagerUserStatus"
        }), graphql(getUserQuery, {
            options: () => ({
                    variables: {
                        uid: 0
                    },
                    errorPolicy: "all",
                    fetchPolicy: 'cache-and-network'
                }),
                name: "getUserQuery"
        }), graphql(mutateUsers, {
                name: "updateUser"
        }), graphql(getUserPassword, {
                name: "getUserPassword"
        })
);




// WEBPACK FOOTER //
// ./src/views/users/graph.js